import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';
import { OfertaYNoticia } from '../../models/ofertaynoticia.model';
import { VariablesGlobales } from '../../providers/variables-globales';

/**
 * Generated class for the NoticiaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-noticia',
  templateUrl: 'noticia.html',
})
export class NoticiaPage {
  public noticia: OfertaYNoticia;

  constructor(public navCtrl: NavController, public navParams: NavParams,public menuCtrl:MenuController, public global: VariablesGlobales,) {
    this.noticia = navParams.get("noticia");
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  compartir(){
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad NoticiaPage');
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/noticia/noticia.ts